/// <amd-module name="Test/AttachmentsView/Actions/AttachmentsViewActionsHub" />
import { ISelectedAttachment } from "Test/AttachmentsView/Attachment";
import { TestAttachmentModel } from "Test/AttachmentsView/TestAttachmentModel";
import { Action } from "VSS/Reflux/Action";

export class AttachmentsViewActionsHub {
    public setDefaultState = new Action<null>();
    public onError = new Action<string>();
    public onErrorInPreview = new Action<string>();
    public attachmentsLoaded = new Action<TestAttachmentModel>();
    public showAttachmentPreview = new Action<string>();
    public setLastSelectedAttachment = new Action<ISelectedAttachment>();
    public setLastSelectedAttachmentUnpreviewable = new Action<null>();
    public setAttachmentContentLoading = new Action<null>();
    public closeErrorMessage = new Action<null>();
    public updateContextMenuOpenIndex = new Action<number>();
    public updateCurrentAttachmentPreviewMode = new Action<boolean>();
}
